const route = "/customers";

export { route };
